import { computed } from 'vue';

export default function useViewAccess(repo, context) {
  const updateView = (view, options) => {
    if (context.canEdit.value === false) {
      return new Promise((resolve) => { resolve(view); });
    }

    if (view.isTemp === true) {
      return repo.updateView({ ...view, isPublic: context.isPublic.value }, options);
    }
    return repo.updateView(view, options);
  };

  const deleteView = (view) => {
    if (context.canEdit.value === false) {
      return new Promise((resolve) => { resolve(view); });
    }

    return repo.deleteView(view);
  };

  const createViews = (views, viewOrder) => {
    if (context.canEdit.value === false) {
      return new Promise((resolve) => { resolve(views); });
    }

    return repo.createViews(views.map((v) => ({ ...v, isPublic: context.isPublic.value })), viewOrder);
  };

  const views = computed(() => repo.views.value.map((v) => {
    if (context.canEdit.value) {
      return { ...v, canEdit: true };
    }

    return { ...v, canEdit: v.isPublic === false && v.uid !== 0 };
  }));

  const setParams = (view, params, key) => {
    if (context.readOnly.value === true) {
      return new Promise((resolve) => { resolve(view); });
    }

    return repo.setParams(view, params, key);
  };

  const updateSort = (view, sortOperation) => {
    if (context.readOnly.value === true) {
      return new Promise((resolve) => { resolve(view); });
    }

    return repo.updateSort(view, sortOperation);
  };

  const updateCycles = (view, goalCycles, unassignedGoalCycleSelected) => {
    if (context.readOnly.value === true) {
      return;
    }

    repo.updateCycles(view, goalCycles, unassignedGoalCycleSelected);
  };

  const updateLockCyclesOnView = (view, lockCycleOnView, goalCycles, unassignedGoalCycleSelected) => {
    if (context.readOnly.value === true) {
      return;
    }

    repo.updateLockCyclesOnView(view, lockCycleOnView, goalCycles, unassignedGoalCycleSelected);
  };

  return {
    createLoading: repo.createLoading,
    createViews,

    loadingUpdateView: repo.loadingUpdateView,
    updateView,

    loadingDeleteView: repo.loadingDeleteView,
    deleteView,

    setParams,
    updateSort,
    updateCycles,
    updateLockCyclesOnView,

    resetView: repo.resetView,

    unsavedChanges: repo.unsavedChanges,

    views,
  };
}
